import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// The $localize macro comes from the polyfill "@angular/localize/init" in
// angular.json (build options), which loads before this file. A direct import
// here made the build warn "Direct import of '@angular/localize/init'".

const monacoBaseURL = '/assets/monaco-editor/min/vs';
const loaderScript = document.createElement('script');
loaderScript.src = `${monacoBaseURL}/loader.js`;
loaderScript.onload = () => {
  (window as any).require.config({ paths: { vs: monacoBaseURL } });
  (window as any).require(['vs/editor/editor.main'], () => {});
};
document.head.appendChild(loaderScript);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
